import axios from 'axios';

export function fetchGroups(projectId) {
  return axios.get(`/projects/${projectId}/groups`);
}

export function fetchGroupInstance(projectId, groupId, instanceId) {
  return axios.get(
    `/projects/${projectId}/groups/${groupId}/instances/${instanceId}`
  );
}
export function updateGroupInstance(projectId, groupId, instanceId, instance) {
  return axios.put(
    `/projects/${projectId}/groups/${groupId}/instances/${instanceId}`,
    instance
  );
}

export function fetchGroupInstances(projectId, groupId) {
  return axios.get(`/projects/${projectId}/groups/${groupId}/instances`);
}

export function fetchGroupUsers(projectId, groupId) {
  return axios.get(`/projects/${projectId}/groups/${groupId}/users`);
}

export function fetchGroupInstanceStatuses(projectId, groupId) {
  return axios.get(`/projects/${projectId}/groups/${groupId}/instances_status`);
}

export function submitNewGroup(projectId, { groupName }) {
  const url = `/projects/${projectId}/groups`;
  const payload = {
    name: groupName
  };
  return axios.post(url, payload);
}

export function deleteGroups(projectId, groupIds, { returnSettingsToDefault }) {
  const url = `/projects/${projectId}/groups/remove`;
  return axios.post(url, {
    group_ids: groupIds,
    reset_instances: returnSettingsToDefault
  });
}

export function addFlexboxesToGroup(projectId, groupId, flexboxesIds) {
  const url = `/projects/${projectId}/groups/${groupId}/instances`;
  const payload = {
    instance_ids: flexboxesIds
  };

  return axios.put(url, payload);
}

export function getFlexboxesWithoutGroup(projectId) {
  const url = `/projects/${projectId}/instances/ungrouped`;
  return axios.get(url);
}

export function removeGroupInstances(
  projectId,
  groupId,
  { instanceIds, resetInstances }
) {
  const url = `/projects/${projectId}/groups/${groupId}/instances/remove`;
  return axios.post(url, {
    instance_ids: instanceIds,
    reset_instances: resetInstances
  });
}

export function updateGroup(projectId, groupId, group) {
  const url = `/projects/${projectId}/groups/${groupId}`;
  const payload = group;
  return axios.put(url, payload);
}

export function createGroupUser(projectId, groupId, user) {
  const url = `/projects/${projectId}/groups/${groupId}/users`;
  return axios.post(url, user);
}

export function updateGroupUsers(projectId, groupId, groupUsers) {
  const url = `/projects/${projectId}/groups/${groupId}/users`;
  const payload = {
    group_users: groupUsers
  };
  return axios.put(url, payload);
}

export function deleteGroupUsers(projectId, groupId, userIds = []) {
  const url = `/projects/${projectId}/groups/${groupId}/users/remove`;
  const payload = {
    user_ids: userIds
  };
  return axios.post(url, payload);
}

export function submitResetGroupInstanceSettings(
  projectId,
  groupId,
  instanceId
) {
  const url = `/projects/${projectId}/groups/${groupId}/instances/${instanceId}/reset`;

  return axios.post(url);
}
